import NavBar from "@/components/site/NavBar";
import Hero from "@/components/site/Hero";
import AttorneyBar from "@/components/site/AttorneyBar";
import FearSection from "@/components/site/FearSection";
import FounderStory from "@/components/site/FounderStory";
import GoogleReviews from "@/components/site/GoogleReviews";
import Testimonials from "@/components/site/Testimonials";
import FinalCTA from "@/components/site/FinalCTA";
import Footer from "@/components/site/Footer";
import { useAbRedirect } from "@/lib/useAbRedirect";

const headline = (
  <>
    Divorce doesn&rsquo;t have to{" "}
    <span className="italic font-medium text-ink">cost you everything.</span>
    <br className="hidden md:block" />
    But the wrong attorney{" "}
    <span className="italic font-medium text-teal">might.</span>
  </>
);

const subhead = (
  <>
    Mr. Binoye Jos, Esq. built this firm after hiring{" "}
    <span className="text-ink font-medium">two prominent law firms</span>,
    spending <span className="text-ink font-medium">$400,000</span>, and being
    told he&rsquo;d never get equal custody of his son. He fired them,
    represented himself, won equal custody, then went to law school. He knows
    what&rsquo;s at stake when your finances, your home, and your
    children&rsquo;s future are all on the table at once.
  </>
);

const pullquote = (
  <>
    Your marriage may be ending. Your life is not.{" "}
    <span className="italic text-teal">
      We will protect what you&rsquo;ve built — and guide you toward a
      brighter future.
    </span>
  </>
);

const fears = [
  "Will I lose the house?",
  "How will this affect my kids?",
  "Am I going to be okay financially?",
  "Can I trust my attorney to protect what I've built?",
  "What if I agree to something I'll regret?",
];

const founderHeading = (
  <>
    He built this firm{" "}
    <span className="italic">because two attorneys</span> failed him first.
  </>
);

const founderParagraphs = [
  "Binoye Jos hired two prominent law firms and spent $400,000 on his own divorce and custody case. Both firms told him he'd never get equal custody. He fired them, represented himself — and won equal custody. Then he went to law school. Most attorneys treat this as a job; he left corporate America to be a father.",
  "Jos Family Law was built so the next spouse, the next parent, the next person standing in a courtroom never has to discover that lesson alone.",
];

const divorceTestimonials = [
  {
    name: "Mr. R. Thompson",
    quote:
      "I came into this terrified of losing the house and access to my kids. Jos Family Law was patient when I needed patience and aggressive when it counted. The settlement I walked away with let me start over with dignity.",
  },
  {
    name: "Ms. A. Patel",
    quote:
      "I had a previous attorney who told me to just take whatever was offered. Binoye and his team looked at the same facts and saw a completely different path. Months later I had what I was actually entitled to — and a future I could plan around.",
  },
  {
    name: "Mr. D. Nguyen",
    quote:
      "Hands down the most prepared, most honest family law firm I spoke with. They told me what was realistic, not what I wanted to hear. That's exactly why I hired them — and why the outcome held up.",
  },
];

export default function Divorce() {
  useAbRedirect(
    "/orange-county-divorce-attorney-vsl",
    "/orange-county-divorce-attorney-vsl-v2",
    "divorce"
  );
  return (
    <main data-testid="divorce-page" className="relative bg-paper text-ink">
      <NavBar />
      <Hero
        headline={headline}
        subhead={subhead}
        pullquote={pullquote}
        pullquoteLabel="Our Promise"
        source="Divorce"
      />
      <AttorneyBar />
      <FearSection fears={fears} />
      <FounderStory
        heading={founderHeading}
        paragraphs={founderParagraphs}
      />
      <GoogleReviews />
      <Testimonials
        items={divorceTestimonials}
        heading={
          <>
            Satisfied <span className="italic">divorce</span> clients.
          </>
        }
        clientLabel="Divorce Client"
      />
      <FinalCTA source="Divorce" />
      <Footer />
    </main>
  );
}
